import { AppMode } from 'src/store/actions/appMode';
import { useAppSelector } from 'universal-scripts';

export const useIsBubbleWidget = (): boolean => {
	return useAppSelector((s) => (s.appMode as AppMode) === 'widget');
};
